<template>
  <a-switch
    v-bind="instance"
    v-model="defaultValue"
    default-checked
    @change="onChange" />
</template>

<script>
export default {
  props: {
    instance: Object // 配置
  },
  data() {
    return {
      defaultValue: true
    }
  },
  watch: {
    instance: {
      handler(nVal) {
        Object.assign(this, { ...nVal }) // 把传入的参数，融合到this中
        // this.$emit('change', this.defaultValue)
        // console.log(this.defaultValue)
      },
      deep: true,
      immediate: true
    }
  },
  // mounted() {
  //   this.defaultValue = true
  //   this.onChange(this.defaultValue)
  // },
  methods: {
    onChange(value) {
      this.$emit('change', value)
    }
  }
}
</script>

<style>

</style>